import { Icon } from "@iconify/react";

type Props = {
  icon: string;
  label: string;
  onClick: () => void;
  highlighted?: boolean;
};

const ShareOption: React.FC<Props> = ({
  icon,
  label,
  onClick,
  highlighted = false,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`
      flex items-center gap-3 w-full px-4 py-3
      transition cursor-pointer
      focus:outline-none focus:bg-gray-100 dark:focus:bg-gray-800
      ${highlighted
        ? "bg-primary-50 dark:bg-primary-900/20 text-primary-700 dark:text-primary-300"
        : "hover:bg-gray-50 dark:hover:bg-gray-800"
      }
    `}
  >
    <span
      className={`
        flex items-center justify-center
        w-9 h-9 rounded-full
        ${highlighted
          ? "bg-primary-100 dark:bg-primary-900/40"
          : "bg-gray-100 dark:bg-gray-800"
        }
      `}
    >
      <Icon
        icon={icon}
        className={`w-5 h-5 ${
          highlighted ? "text-primary-600" : "text-tealGreen dark:text-primary"
        }`}
      />
    </span>

    <span className="font-medium text-sm dark:text-white">
      {label}
    </span>
  </button>
);

export default ShareOption;